module.exports = __webpack_public_path__ + "static/media/Logo.31e26899.jpg";